import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format large numbers for display
 * e.g., 1234 → "1.2K", 15000 → "15K", 1500000 → "1.5M"
 */
export function formatLargeNumber(num) {
  if (num === null || num === undefined) return '0';
  if (num < 1000) return num.toString();
  if (num < 10000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  if (num < 1000000) return Math.round(num / 1000) + 'K';
  if (num < 10000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  return Math.round(num / 1000000) + 'M';
}
